/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Open_DescInputs */

const en_pc_online_task_open_desc = /** @type {(inputs: Pc_Online_Task_Open_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag a PDF anywhere onto the app, or click Open file. Each document opens in its own tab, and password-protected PDFs ask for the password first.`)
};

const zh_pc_online_task_open_desc = /** @type {(inputs: Pc_Online_Task_Open_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把 PDF 拖到应用中的任意位置，或点击 Open file。每个文档都会在独立的标签页中打开，受密码保护的 PDF 会先要求输入密码。`)
};

/**
* | output |
* | --- |
* | "Drag a PDF anywhere onto the app, or click Open file. Each document opens in its own tab, and password-protected PDFs ask for the password first." |
*
* @param {Pc_Online_Task_Open_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_open_desc = /** @type {((inputs?: Pc_Online_Task_Open_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Open_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_open_desc(inputs)
	return zh_pc_online_task_open_desc(inputs)
});
export { pc_online_task_open_desc as "pc.online.task.open.desc" }